<div class="layout">
  <app-top-nav class="layout-header" (clickEvent)="toggleMini()"></app-top-nav>
  <mat-sidenav-container class="layout-container" autosize>
    <mat-sidenav
      #drawer
      class="layout-sidenav"
      [class.mini-sidebar]="isMini"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="!(isHandset$ | async)"
      [autoFocus]="false"
      [fixedInViewport]="false"
    >
      <div
        class="layout-sidenav-content"
        fxLayout="column"
        fxLayoutAlign="space-between stretch"
      >
        <div fxLayout="column">
          <div class="menu" fxLayout="column">
            <ng-container *ngFor="let item of menuItems()">
              <a
                mat-button
                class="menu-item"
                [routerLink]="!item.disabled && !item.sub ? item.route : null"
                (click)="
                  !item.disabled && handleMenuClick(item, drawer, $event)
                "
                [ngClass]="{
                  selected: isSelected(item),
                  disabled: item.disabled,
                }"
                [attr.aria-disabled]="item.disabled"
                [matTooltip]="(isMini ? item.label : '') | translate"
                matTooltipPosition="right"
              >
                <div
                  class="menu-row"
                  [fxLayout]="isMini ? 'column' : 'row'"
                  fxLayoutAlign="center center"
                  [fxLayoutGap]="isMini ? '4px' : '12px'"
                >
                  <div class="backgroud-icons" [class.no-bg]="isMini">
                    <img
                      [className]="item.class"
                      [src]="isMini ? getIcon(item) : item.icon"
                      *ngIf="item.icon"
                    />
                  </div>
                  <span
                    class="label"
                    [class.text-mini]="isMini"
                    [ngClass]="{ selected: isSelected(item) }"
                    >{{ item.label | translate }}</span
                  >
                  <mat-icon *ngIf="item.sub && !isMini">
                    {{ openedSub[item.route] ? "expand_less" : "expand_more" }}
                  </mat-icon>
                </div>
              </a>

              <div
                class="submenu"
                *ngIf="item.sub && openedSub[item.route] && !isMini"
              >
                <a
                  *ngFor="let sub of item.sub"
                  mat-button
                  class="menu-item submenu-item"
                  [routerLink]="sub.route"
                  (click)="handleSubMenuClick(drawer)"
                  [ngClass]="{ selected: currentUrl === sub.route }"
                >
                  <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="12px"
                  >
                    <span class="label">{{ sub.label | translate }}</span>
                  </div>
                </a>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="footer" fxLayout="column" fxLayoutAlign="end center">
          <div class="version" fxLayout="column" fxLayoutAlign="center center">
            <div>Version</div>
            <div>{{ version }}</div>
            <div class="package">{{ package }}</div>
          </div>
          <a
            href="https://xten-technology.com"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-logo-link"
          >
            <img
              src="assets/shared/images/branding/xten-technology-icon.png"
              class="footer-logo"
              alt="Xten Technology"
            />
          </a>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content class="layout-main-content">
      <div class="layout-sidenav-content-main-component">
        <router-outlet />
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
